import { PlanSupportCompanyInfo } from './vo/PlanSupportCompanyInfoRow';

/**
 * 企画支援選択画面の値を管理するクラス
 *
 * @export KYMW0003Model
 * @class KYMW0003Model
 */
export class KYMW0003Model {
  public output: PlanSupportCompanyInfo;
  public planSupportCompanyInfoList: PlanSupportCompanyInfo[];
}
